import React, {useState, useEffect, memo} from 'react'

export const BackToTop = memo(() => {
    const [btnGoToTop, setBtnGoToTop] = useState('')
    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 1000) {
                setBtnGoToTop('visible');
            } else {
                setBtnGoToTop('');
            }
        });
    }, []);

    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    return (
        <div id="aside-to-top" className={btnGoToTop} onClick={(event) => goToTop()}>Haut</div>
    )
})